export enum SafetyConcern {
  BusStop = "BusStop",
  Parking = "Parking",
  Building = "Building",
  Path = "Path",
  Street = "Street",
  Rail = "Rail",
}

export type DistanceTracking = Record<
  SafetyConcern,
  { left?: number; right?: number }
>;

export class AdjacentFeatureDistances {
  data: DistanceTracking = {
    BusStop: {},
    Parking: {},
    Building: {},
    Path: {},
    Street: {},
    Rail: {}
  };

  registerFeature(
    type: SafetyConcern,
    side: "left" | "right",
    distance: number,
  ) {
    const existingValue = this.data[type][side];

    if (existingValue == null || existingValue > distance) {
      this.data[type][side] = distance;
    }
  }
}
